export const MaxAllowedImages = 5;
export const MaxAllowedFileSize = 8388608; // 8mB
export const MaxAllowedFileSizeHumanReadable = "8MB";
export const AllowedFileExtensions = ["jpg", "jpeg", "gif", "png"];
